import React from 'react';
import { Card } from '@/components/ui/card';
import { Calculator } from 'lucide-react';

/**
 * Document Totals Panel
 * Sticky summary panel for right sidebar
 */
const DocumentTotalsPanel = ({ totals = {}, enableRoundOff = true, onToggleRoundOff }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount || 0);
  };

  return (
    <Card 
      className="p-4 lg:p-6 border-2 shadow-xl lg:sticky lg:top-24" 
      style={{
        borderColor: '#fcd34d',
        background: 'linear-gradient(135deg, #fefce8 0%, #fef3c7 100%)'
      }}
    >
      <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide flex items-center gap-2 mb-4">
        <div className="p-2 rounded-lg bg-yellow-200">
          <Calculator className="w-4 h-4 text-yellow-700" />
        </div>
        Summary
      </h3>

      <div className="space-y-3">
        <div className="flex justify-between items-center text-sm">
          <span className="text-gray-600">Subtotal</span>
          <span className="font-semibold text-gray-900">{formatCurrency(totals.subtotal || 0)}</span>
        </div>

        {totals.discount_total > 0 && (
          <div className="flex justify-between items-center text-sm">
            <span className="text-gray-600">Discount</span>
            <span className="font-semibold text-green-600">- {formatCurrency(totals.discount_total || 0)}</span>
          </div>
        )}

        <div className="flex justify-between items-center text-sm">
          <span className="text-gray-600">Taxable Amount</span>
          <span className="font-semibold text-gray-900">{formatCurrency(totals.taxable_amount || 0)}</span>
        </div>

        <div className="flex justify-between items-center text-sm">
          <span className="text-gray-600">Tax</span>
          <span className="font-semibold text-blue-600">+ {formatCurrency(totals.tax_total || 0)}</span>
        </div>

        {enableRoundOff && totals.round_off !== undefined && totals.round_off !== 0 && (
          <div className="flex justify-between items-center text-sm">
            <span className="text-gray-600">Round Off</span>
            <span className="font-semibold text-gray-700">
              {totals.round_off > 0 ? '+' : ''} {formatCurrency(Math.abs(totals.round_off || 0))}
            </span>
          </div>
        )}

        <div className="border-t-2 border-yellow-300 pt-3 mt-3">
          <div className="flex justify-between items-center">
            <span className="text-base font-bold text-gray-800">Grand Total</span>
            <span className="text-lg font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              {formatCurrency(totals.grand_total || 0)}
            </span>
          </div>
        </div>

        {onToggleRoundOff && (
          <div className="pt-2">
            <label className="flex items-center gap-2 text-xs text-gray-600 cursor-pointer">
              <input
                type="checkbox"
                checked={enableRoundOff}
                onChange={(e) => onToggleRoundOff(e.target.checked)}
                className="rounded border-gray-300"
              />
              Enable round off
            </label>
          </div>
        )}
      </div>
    </Card>
  );
};

export default DocumentTotalsPanel;